'kiwi public';

import _sortInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/sort";
import _filterInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/filter";
import _mapInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/map";
import _Object$values from "@babel/runtime-corejs3/core-js-stable/object/values";
import _findInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/find";
import GlobalApi from '@/libs/GlobalApi';
import toHtml from '@/libs/renderers/Html';
import parseMessage from '@/libs/MessageParser';
import AutoComplete from './AutoComplete';
export default {
  components: {
    AutoComplete: AutoComplete
  },
  props: ['network', 'buffer', 'sidebarState'],
  data: function data() {
    return {
      self: this,
      pluginUiSections: GlobalApi.singleton().aboutBufferPlugins,
      closedSections: {},
      inviteNick: ''
    };
  },
  computed: {
    b: function b() {
      return this.buffer || {};
    },
    formattedTopic: function formattedTopic() {
      var blocks = parseMessage(this.b.topic || '', {
        extras: false
      });
      var content = toHtml(blocks);
      return content;
    },
    highlights: function highlights() {
      var _context, _context2, _context3, _context4, _context5, _context6;
      // Tap into buffer.message_count to force vuejs to update this function when
      // it changes
      /* eslint-disable no-unused-vars */
      var tmp = this.buffer.message_count;
      return _sortInstanceProperty(_context = _filterInstanceProperty(_context2 = _filterInstanceProperty(_context3 = _filterInstanceProperty(_context4 = _filterInstanceProperty(_context5 = _filterInstanceProperty(_context6 = this.buffer.getMessages()).call(_context6, function (m) {
        return m.isHighlight;
      })).call(_context5, function (m) {
        return m.type !== 'traffic';
      })).call(_context4, function (m) {
        return m.type !== 'topic';
      })).call(_context3, function (m) {
        return m.type !== 'mode';
      })).call(_context2, function (m) {
        return m.html;
      })).call(_context, function (a, b) {
        return b.time - a.time;
      });
    },
    areWeAnOp: function areWeAnOp() {
      return this.buffer.isUserAnOp(this.network.nick);
    },
    invitableUsers: function invitableUsers() {
      var _this = this,
        _context7,
        _context8;
      var wantedBuffer = function wantedBuffer(userBuffer) {
        return userBuffer.buffer.name === _this.buffer.name;
      };
      return _mapInstanceProperty(_context7 = _filterInstanceProperty(_context8 = _Object$values(this.network.users)).call(_context8, function (user) {
        var _context9;
        return !_findInstanceProperty(_context9 = _Object$values(user.buffers)).call(_context9, wantedBuffer);
      })).call(_context7, function (user) {
        return {
          text: user.nick
        };
      });
    }
  },
  methods: {
    toggleSection: function toggleSection(section) {
      this.$set(this.closedSections, section, !this.closedSections[section]);
    },
    inviteUser: function inviteUser() {
      if (!this.inviteNick) {
        return;
      }
      this.network.ircClient.invite(this.buffer.name, this.inviteNick);
      this.inviteNick = '';
    },
    inviteSelected: function inviteSelected(value, item) {
      this.inviteNick = value;
    },
    inviteKeyDown: function inviteKeyDown(event) {
      if (event.key === 'Tab') {
        this.$refs.autocomplete.selectCurrentItem();
        return;
      }
      this.$refs.autocomplete.handleOnKeyDown(event);
    }
  }
};
window._kiwi_exports = window._kiwi_exports || {};
if(!window._kiwi_exports["components"]) window._kiwi_exports["components"] = {};
window._kiwi_exports["components"]["SidebarAboutBuffer"]
window._kiwi_exports.components.SidebarAboutBuffer = (typeof exports !== 'undefined' ? (exports.default || exports) : (typeof module !== 'undefined' && module.exports ? (module.exports.default || module.exports) : {}));
